"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDisplayEaningsDto = void 0;
class GetDisplayEaningsDto {
    displayId;
    from;
    to;
    groupBy;
}
exports.GetDisplayEaningsDto = GetDisplayEaningsDto;
